import { Controller, useFormContext } from 'react-hook-form'

import { CheckBoxGroup, FF2 } from 'ui/components'
import { SarEdit } from '~bank-bsa-reporting/types'

import { suspiciousActivityInfoValidate } from '../../../../../hooks'

export const Mortgage = () => {
  const { control } = useFormContext<SarEdit>()
  return (
    <Controller
      name="suspiciousActivityInfo.mortgage"
      control={control}
      rules={{
        validate: suspiciousActivityInfoValidate
      }}
      render={({ field }) => (
        <FF2
          field={field}
          label="41. Mortgage Fraud"
          input={(props) => (
            <CheckBoxGroup
              {...props}
              data-qa={'41. Mortgage Fraud'}
              direction={'vertical'}
              data={[
                { label: 'a. Application fraud', value: 'a' },
                { label: 'b. Appraisal fraud', value: 'b' },
                { label: 'c. Foreclosure/Short sale fraud', value: 'c' },
                { label: 'd. Loan Modification fraud', value: 'd' },
                { label: 'e. Origination fraud', value: 'e' },
                { label: 'z. Other', value: 'z' }
              ]}
            />
          )}
        />
      )}
    />
  )
}
